import React from "react";
import { Link, useLocation } from "react-router-dom";
import { TEST_IDS } from "@/constants/testIds";
import { Zap, Image as ImageIcon } from "lucide-react";

export default function Layout({ children }) {
  const { pathname } = useLocation();

  const linkClass = (active) =>
    `font-anton uppercase text-lg px-4 py-2 border-[3px] border-black transition-all duration-150 ${
      active
        ? "bg-[#CE1126] text-white shadow-none translate-x-[3px] translate-y-[3px]"
        : "bg-white text-black shadow-[3px_3px_0_0_#000] hover:-translate-y-0.5 hover:translate-x-0 hover:shadow-[5px_5px_0_0_#000]"
    }`;

  return (
    <div className="min-h-screen relative overflow-x-hidden">
      <div className="confetti-bg absolute inset-0 pointer-events-none" aria-hidden />

      {/* Top striped bar */}
      <div className="h-2 w-full flex" aria-hidden>
        <div className="flex-1" style={{ background: "#006847" }} />
        <div className="flex-1 bg-white" />
        <div className="flex-1" style={{ background: "#CE1126" }} />
      </div>

      <header className="relative z-10 max-w-4xl mx-auto flex items-center justify-between px-4 py-4">
        <Link to="/" className="flex items-center gap-3" data-testid={TEST_IDS.navHome}>
          <div className="w-11 h-11 bg-[#FFD100] border-[3px] border-black shadow-[3px_3px_0_0_#000] flex items-center justify-center rotate-[-4deg]">
            <Zap strokeWidth={3} className="w-6 h-6 text-black" />
          </div>
          <div className="leading-none">
            <div className="font-anton uppercase text-2xl sm:text-3xl tracking-tight">
              Caliche <span className="text-[#CE1126]">Mundial</span>
            </div>
            <div className="font-outfit text-xs uppercase tracking-widest text-black/60">
              Stickers Chingones
            </div>
          </div>
        </Link>

        <nav className="flex items-center gap-2 sm:gap-3">
          <Link to="/" className={linkClass(pathname === "/")} data-testid="nav-create-link">
            Crear
          </Link>
          <Link
            to="/gallery"
            className={linkClass(pathname === "/gallery")}
            data-testid={TEST_IDS.navGallery}
          >
            <span className="inline-flex items-center gap-1.5">
              <ImageIcon strokeWidth={3} className="w-4 h-4" />
              Galería
            </span>
          </Link>
        </nav>
      </header>

      <main className="relative z-10 max-w-4xl mx-auto px-4 pb-24">{children}</main>

      <footer className="relative z-10 max-w-4xl mx-auto px-4 py-8 text-center">
        <p className="font-outfit text-sm text-black/70">
          Hecho con <span className="text-[#CE1126] font-bold">❤</span> para todos los que le van al{" "}
          <span className="font-anton uppercase">Tri</span>
        </p>
      </footer>
    </div>
  );
}
